import { useUser } from '../contexts/UserContext'
import { permissionType } from '../utils/constants'

export const useOrders = () => {
  const { canAccess } = useUser()

  const canViewOrders = canAccess(permissionType.TAB_ORDERS, 0)
  const canEditOrders = canAccess(permissionType.EDIT_ORDERS, 0)
  const canRefundOrders = canAccess(permissionType.REFUND_ORDERS, 0)
  const canCancelOrders = canAccess(permissionType.CANCEL_ORDERS, 0)
  const canExportOrdersData = canAccess(permissionType.EXPORT_ORDER_DATA, 0)

  return {
    canViewOrders,
    canEditOrders,
    canRefundOrders,
    canCancelOrders,
    canExportOrdersData
  }
}
